import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ScrollToTop from 'sharedComponents/scrollToTop'
import HomeLayout from 'layouts/homeLayout'
import Home from 'pages/home'
import ProductsListing from 'pages/products/productsListing/index1'
import SearchProductsListing from 'pages/products/searchProductsListing'
import ProductDetails from 'pages/products/productDetails'
import About from 'pages/about'
import Contact from 'pages/contact'
import PageForbidden from 'sharedComponents/403'
import PageNotFound from 'sharedComponents/404'

const Router = () => {
  // const isAuthenticated = false

  // const isAuthenticated = useSelector(
  //   (state) => state?.authReducer?.isAuthenticated || false
  // )

  // const PrivateRoute = ({ children }) => {
  //   if (isAuthenticated) {
  //     return (
  //       <>
  //         <HomeLayout children={children} />
  //       </>
  //     )
  //   } else return <Navigate to="/" />
  // }
  // const HomeRoute = () => {
  //   if (isAuthenticated) {
  //     return <Navigate replace to="/dashboard" />
  //   } else return <Login />
  // }

  const Layout = ({ children, contactVisible }) => {
    return (
      <>
        <HomeLayout children={children} contactVisible={contactVisible} />
      </>
    )
  }

  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          {/* <Route path="/products">
            <Route
              index
              element={
                <Layout>
                  <ProductsListing />
                </Layout>
              }
            />
            <Route
              path=":productId"
              element={
                <Layout>
                  <ProductDetails />
                </Layout>
              }
            />
          </Route> */}
          <Route path="/shop">
            <Route
              index
              element={
                <Layout>
                  <ProductsListing />
                </Layout>
              }
            />
            <Route
              path=":mainCategory"
              element={
                <Layout>
                  <ProductsListing />
                </Layout>
              }
            />
            <Route
              path=":mainCategory/:subCategory"
              element={
                <Layout>
                  <ProductsListing />
                </Layout>
              }
            />
          </Route>
          <Route
            path="/products"
            element={
              <Layout>
                <SearchProductsListing />
              </Layout>
            }
          />
          <Route
            path="/product/:productId"
            element={
              <Layout contactVisible={false}>
                <ProductDetails />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path="/contactus"
            element={
              <Layout>
                <Contact />
              </Layout>
            }
          />
          <Route path="/403" element={<PageForbidden />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  )
}

export default Router
